export const formatCustomerInfo = (value: string | null | undefined, fallback = 'Not provided') => {
  if (!value || value.trim() === '') return fallback
  return value.trim()
}
